<div class="content">
    <div class="myraw">
        <app-appheader class="app-appheader"></app-appheader>
    </div>
    <div class="outlet">
        <router-outlet></router-outlet>
    </div>
</div>